import clsx from 'clsx'

export function Logomark({
  invert = false,
  filled = false,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  invert?: boolean
  filled?: boolean
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 409 384"
      aria-hidden="true"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100 100.244C100 100.109 100.112 100 100.251 100L201.626 100.004C220.104 100.265 235 114.938 235 133C235 151.225 219.833 166 201.125 166L133.374 165.996C114.896 165.735 100 151.062 100 133V100.244Z"
        className={invert ? 'fill-white' : 'fill-cyan-700'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M173 250.611V184.157C173 183.464 173.555 182.901 174.241 182.901H206.969C224.158 182.392 238 168.38 238.504 150.981V150.246C238.504 150.11 238.614 150 238.75 150C238.888 150 239 150.112 239 150.25V250.611H238.986C238.986 269.051 224.218 284 206 284C187.782 284 173 269.051 173 250.611Z"
        className={invert ? 'fill-white' : 'fill-cyan-700'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M275.993 100.014V100H307.759C308.444 100 309 100.556 309 101.241V133.007H308.986C308.986 151.229 294.214 166 275.993 166C257.771 166 243 151.229 243 133.007C243 114.786 257.771 100.014 275.993 100.014Z"
        className={invert ? 'fill-white' : 'fill-cyan-700'}
      />
    </svg>
  )
}

export function Logo({
  className,
  invert = false,
  filled = false,
  fillOnHover = false,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  invert?: boolean
  filled?: boolean
  fillOnHover?: boolean
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 7375 876"
      aria-hidden="true"
      className={clsx(fillOnHover && 'group/logo', className)}
      {...props}
    >
      <path
        fillRule="nonzero"
        d="M290.712,875.781l0,-725.608l209.028,0l0,725.608l-209.028,0Zm-290.712,-707.552l-0,-168.229l794.01,0l0,168.229l-794.01,0Z"
        className={invert ? 'fill-white' : 'fill-zinc-950'}
      />
      <path
        fillRule="nonzero"
        d="M983.858,875.781l0,-875.781l210.243,0l0,875.781l-210.243,0Zm683.594,0l0,-875.781l210.243,0l0,875.781l-210.243,0Zm-505.816,-363.976l0,-165.799l537.066,0l0,165.799l-537.066,0Z"
        className={invert ? 'fill-white' : 'fill-zinc-950'}
      />
      <path
        fillRule="nonzero"
        d="M2122.729,875.781l0,-875.781l742.448,0l0,165.799l-580.208,0l48.003,-46.875l0,637.934l-48.003,-46.875l582.552,0l0,165.799l-744.792,0Zm165.799,-365.191l0,-154.948l516.58,0l0,154.948l-516.58,0Z"
        className={invert ? 'fill-white' : 'fill-zinc-950'}
      />
      <path
        fillRule="nonzero"
        d="M3074.191,875.781l0,-875.781l450.521,0c80.078,0 145.161,11.632 195.226,34.896c50.043,23.22 87.283,56.25 111.719,99.132c24.414,42.839 36.632,93.468 36.632,151.91c0,65.69 -14.236,119.575 -42.708,161.632c-28.429,42.014 -68.468,73.242 -120.139,93.663c-51.628,20.443 -112.283,30.642 -181.944,30.642l-255.903,0l0,-147.743l234.288,0c53.646,0 92.882,-11.806 117.708,-35.417c24.826,-23.655 37.24,-55.512 37.24,-95.573c0,-47.222 -14.041,-80.642 -42.101,-100.26c-28.016,-19.661 -65.625,-29.514 -112.847,-29.514l-263.108,0l45.66,-45.573l0,757.986l-210.243,0Z"
        className={invert ? 'fill-white' : 'fill-zinc-950'}
      />
      <path
        fillRule="nonzero"
        d="M3921.164,875.781l374.826,-875.781l271.441,0l376.042,875.781l-227.083,0l-239.062,-610.243l-42.014,-112.934l-7.205,0l-43.229,114.149l-237.847,609.028l-225.868,0Zm279.861,-175.347l57.726,-156.25l345.92,0l56.51,156.25l-460.156,0Z"
        className={invert ? 'fill-white' : 'fill-zinc-950'}
      />
      <path
        fillRule="nonzero"
        d="M5124.878,875.781l0,-875.781l210.243,0l0,747.222l-45.66,-43.229l482.986,0l0,171.788l-647.569,0Z"
        className={invert ? 'fill-white' : 'fill-zinc-950'}
      />
      <rect
        x="5962.213"
        y="0"
        width="210.243"
        height="875.781"
        className={invert ? 'fill-white' : 'fill-zinc-950'}
      />
      <path
        fillRule="nonzero"
        d="M6352.677,875.781l374.826,-875.781l271.441,0l376.042,875.781l-227.083,0l-239.062,-610.243l-42.014,-112.934l-7.205,0l-43.229,114.149l-237.847,609.028l-225.868,0Zm279.861,-175.347l57.726,-156.25l345.92,0l56.51,156.25l-460.156,0Z"
        className={invert ? 'fill-white' : 'fill-zinc-950'}
      />
    </svg>
  )
}
